//src/components/ui/TimeRangeLinks.tsx
import React from 'react';
import { theme } from 'antd';

// Базовые периоды (без "all")
type BasicPeriod = 'day' | 'week' | 'month' | 'year';
// Расширенный набор c "all"
type Period = BasicPeriod | 'all';

type Props<T extends Period = BasicPeriod> = {
  value: T;
  onChange: (p: T) => void;
  /** Если true — добавим "Всё время" */
  withAll?: boolean;
  labels?: Partial<Record<Period, string>>;
  gap?: number;
};

const DEFAULT_LABELS: Record<Period, string> = {
  day: '24 ч',
  week: 'Неделя',
  month: 'Месяц',
  year: 'Год',
  all: 'Всё время',
};

export function TimeRangeLinks<T extends Period = BasicPeriod>({
  value,
  onChange,
  withAll = false,
  labels,
  gap = 12,
}: Props<T>) {
  const { token } = theme.useToken();
  const L = { ...DEFAULT_LABELS, ...(labels || {}) };

  // Если withAll=false — рендерим только базовые 4 периода,
  // так onChange не сможет получить 'all' (тип T остаётся базовым).
  const ranges = (withAll
    ? (['day', 'week', 'month', 'year', 'all'] as T[])
    : (['day', 'week', 'month', 'year'] as T[])
  );

return (
    <nav aria-label="Фильтр по диапазону времени" style={{ display: 'flex', gap }}>
      {ranges.map((r) => {
        const active = r === value;
        return (
          <button
            key={String(r)}
            type="button"
            onClick={() => onChange(r)}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              font: 'inherit',
              fontWeight: active ? 600 : 500,
              color: active ? token.colorPrimary : token.colorText,
              textDecoration: active ? 'underline' : 'none',
              opacity: active ? 1 : 0.85,
              cursor: 'pointer',
            }}
          >
            {L[r]}
          </button>
        );
      })}
    </nav>
  );
}
